{
  "name": "pokemon-auto-chess",
  "version": "6.8.0",
  "description": "",
  "keywords": [],
  "license": "BSD-3-Clause",
  "engines": {
    "node": ">=20.16.0",
    "npm": ">=10.8.1"
  },
  "homepage": "https://github.com/keldaanCommunity/pokemonAutoChess#readme",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/keldaanCommunity/pokemonAutoChess.git"
  },
  "bugs": {
    "url": "https://github.com/keldaanCommunity/pokemonAutoChess/issues"
  },
  "author": "keldaan-ag",
  "contributors": [
    "ogus",
    "sylvainpolletvillard"
  ],
  "main": "public/dist/server/app/index.js",
  "scripts": {
    "dev-client": "node esbuild.js --dev",
    "dev-server": "ts-node-dev --watch \"src/**/*\" --respawn --transpile-only ./app/index.ts",
    "dev": "npm-run-all --parallel dev-*",
    "lint": "npx @biomejs/biome lint app/",
    "format": "npx @biomejs/biome format app/ --write",
    "check": "npx @biomejs/biome check app/ --write",
    "build-client": "node esbuild.js --build",
    "build-server": "tsc",
    "download-music": "degit --force https://github.com/keldaanCommunity/pokemonAutoChessMusic ./app/public/src/assets/musics",
    "build": "npm run build-client && npm run build-server",
    "start": "node ./app/public/dist/server/app/index.js",
    "monitor-bot": "node ./app/public/dist/server/scheduled/monitor-bot.js",
    "translate": "npx @inlang/cli machine translate -f",
    "postinstall": "npm run download-music && cd edit/assetpack && npm install",
    "assetpack": "cd edit/assetpack && npm run assetpack",
    "csv-export": "cd gen && ts-node csv-export.ts",
    "add-pokemon": "cd edit && ts-node add-pokemon.ts",
    "collection-migration": "node -r ts-node/register --env-file=.env ./db-commands/collection-migration.ts",
    "colyseus-post-deploy": "npx colyseus-post-deploy",
    "deploy-live": "pm2 deploy production update",
    "setup-live": "pm2 deploy production setup",
    "check-circular-refs": "npx madge ./app -- --circular --exclude '^public/dist'"
  },
  "dependencies": {
    "@colyseus/command": "^0.3.1",
    "@colyseus/monitor": "^0.16.6",
    "@colyseus/redis-driver": "^0.16.1",
    "@colyseus/redis-presence": "^0.16.1",
    "@colyseus/schema": "^3.0.70",
    "@colyseus/testing": "^0.16.3",
    "@colyseus/tools": "^0.16.16",
    "@colyseus/ws-transport": "^0.16.5",
    "@joaomoreno/unique-names-generator": "^5.1.0",
    "@reduxjs/toolkit": "^2.3.0",
    "body-parser": "^2.0.0",
    "colyseus": "^0.16.4",
    "colyseus.js": "^0.16.16",
    "cors": "^2.8.5",
    "cron": "^4.3.1",
    "d3": "^7.8.5",
    "dayjs": "^1.11.13",
    "discord.js": "^14.15.1",
    "dotenv": "^17.0.0",
    "express": "^5.2.1",
    "express-basic-auth": "^1.2.0",
    "express-openapi": "^12.1.3",
    "fast-xml-parser": "^5.2.5",
    "firebase": "^10.0.0",
    "firebase-admin": "^12.3.0",
    "firebaseui": "^6.1.0",
    "fs-extra": "^11.2.0",
    "graceful-fs": "^4.2.10",
    "helmet": "^8.0.0",
    "html2canvas": "^1.4.1",
    "i18next": "^25.0.0",
    "i18next-browser-languagedetector": "^8.0.0",
    "i18next-http-backend": "^3.0.0",
    "immer": "^11.0.1",
    "jimp": "^1.6.0",
    "loglevel": "^1.8.1",
    "markdown-to-config": "^0.4.0",
    "marked": "^17.0.0",
    "matter-js": "^0.20.0",
    "mongoose": "^8.9.5",
    "nanoid": "^3.3.8",
    "phaser": "^3.90.0",
    "phaser-animated-tiles-phaser3.5": "^2.0.5",
    "phaser3-rex-plugins": "^1.80.6",
    "pm2-prom-module-client": "^1.0.3",
    "prom-client": "^15.1.1",
    "react": "^19.0.0",
    "react-circular-progressbar": "^2.1.0",
    "react-dom": "^19.0.0",
    "react-i18next": "^16.5.0",
    "react-pro-sidebar": "^1.1.0",
    "react-redux": "^9.1.2",
    "react-router-dom": "^6.28.0",
    "react-tabs": "^6.0.2",
    "react-toastify": "^10.0.6",
    "react-tooltip": "^5.30.0",
    "recharts": "^3.6.0"
  },
  "devDependencies": {
    "@biomejs/biome": "^2.3.8",
    "@types/bootstrap": "^5.2.10",
    "@types/cors": "^2.8.17",
    "@types/d3": "^7.4.3",
    "@types/elo-rank": "^1.0.3",
    "@types/fs-extra": "^11.0.4",
    "@types/matter-js": "^0.20.0",
    "@types/node": "^24.10.1",
    "@types/node-fetch": "^2.6.11",
    "@types/react": "^19.0.0",
    "@types/react-dom": "^19.0.0",
    "csv-writer": "^1.6.0",
    "degit": "^2.8.4",
    "esbuild": "^0.27.0",
    "npm-run-all": "^4.1.5",
    "openapi-typescript": "^7.1.2",
    "pm2": "^6.0.8",
    "ts-node-dev": "^2.0.0",
    "typescript": "^5.7.3"
  }
}
